import { Component, EventEmitter, Output } from '@angular/core';
import { ImageSource } from '@app/features/app-content/services/image-resizing.service';
import { UiModule } from '@app/ui';
import { SelectedImage } from '@app/ui/components/image-upload/image-upload.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'rk-logo-upload',
  templateUrl: './logo-upload.component.html',
  styleUrl: './logo-upload.component.scss',
  imports: [UiModule, TranslateModule, FontAwesomeModule],
})
export class LogoUploadComponent {
  @Output() readonly rawImageSelected = new EventEmitter<{
    source: ImageSource;
    selectedImage: SelectedImage;
  }>();

  onRawImageSelected(selectedImage: SelectedImage) {
    this.rawImageSelected.emit({ source: 'rawLogo', selectedImage });
  }
}
